import { render, staticRenderFns } from "./ExampleIdSearch.vue?vue&type=template&id=2c533a87&"
import script from "./ExampleIdSearch.vue?vue&type=script&lang=js&"
export * from "./ExampleIdSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExampleIdSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports